import type { Session } from '@ory/client';
import { useEffect } from 'react';

const COOKIE_BOT_ID = 'CookieBot';

const loadCookieScript = () => {
	const cookieScript = document.getElementById(COOKIE_BOT_ID);

	if (!cookieScript && !!import.meta.env.VITE_COOKIE_BOT_ID) {
		const script = document.createElement('script');
		script.id = COOKIE_BOT_ID;
		script.src = 'https://consent.cookiebot.com/uc.js';
		script.setAttribute('data-cbid', import.meta.env.VITE_COOKIE_BOT_ID);
		script.setAttribute('data-blockingmode', 'auto');
		script.setAttribute('data-widget-enabled', 'false');
		script.type = 'text/javascript';
		script.async = true;

		const lang = localStorage.getItem('i18nextLng');
		if (lang) {
			script.setAttribute('data-culture', lang);
		}

		document.head.appendChild(script);
	}
};

export const useCookiesBanner = (session?: Session) => {
	useEffect(() => {
		if (session?.active) {
			loadCookieScript();
		}
	}, [session?.active]);
};
